import ContactListsAPI from '../../api/contactLists';
import ListFoldersAPI from '../../api/listFolders';

export const state = {
  records: [],
  folders: [],
  uiFlags: {
    isFetching: false,
    isCreating: false,
  },
};

export const getters = {
  getLists(_state) {
    return _state.records;
  },
  getFolders(_state) {
    return _state.folders;
  },
  getUIFlags(_state) {
    return _state.uiFlags;
  },
  getListById: _state => id =>
    _state.records.find(record => record.id === Number(id)),
};

export const actions = {
  get: async ({ commit }) => {
    commit('SET_CONTACT_LIST_UI_FLAG', { isFetching: true });
    try {
      const [listsResponse, foldersResponse] = await Promise.all([
        ContactListsAPI.get(),
        ListFoldersAPI.get(),
      ]);
      commit('SET_CONTACT_LISTS', listsResponse.data.payload);
      commit('SET_LIST_FOLDERS', foldersResponse.data.payload);
    } finally {
      commit('SET_CONTACT_LIST_UI_FLAG', { isFetching: false });
    }
  },
  create: async ({ commit }, payload) => {
    commit('SET_CONTACT_LIST_UI_FLAG', { isCreating: true });
    try {
      const response = await ContactListsAPI.create(payload);
      commit('ADD_CONTACT_LIST', response.data);
      return response.data;
    } finally {
      commit('SET_CONTACT_LIST_UI_FLAG', { isCreating: false });
    }
  },
  materialize: async ({ dispatch }, payload) => {
    const response = await ContactListsAPI.materialize(payload);
    await dispatch('get');
    return response.data;
  },
  delete: async ({ commit }, id) => {
    await ContactListsAPI.delete(id);
    commit('DELETE_CONTACT_LIST', id);
  },
  addContacts: async ({ dispatch }, { listId, contactIds, listIds }) => {
    await ContactListsAPI.addContacts(listId, {
      contact_ids: contactIds,
      list_ids: listIds,
    });
    await dispatch('get');
  },
  removeContacts: async (
    { dispatch },
    { listId, contactIds, listIds, allLists = false }
  ) => {
    await ContactListsAPI.removeContacts(listId, {
      contact_ids: contactIds,
      list_ids: listIds,
      all_lists: allLists,
    });
    await dispatch('get');
  },
  moveContacts: async ({ dispatch }, { listId, contactIds, toListIds }) => {
    await ContactListsAPI.moveContacts(listId, {
      contact_ids: contactIds,
      to_list_ids: toListIds,
    });
    await dispatch('get');
  },
};

export const mutations = {
  SET_CONTACT_LIST_UI_FLAG(_state, data) {
    _state.uiFlags = { ..._state.uiFlags, ...data };
  },
  SET_CONTACT_LISTS(_state, data) {
    _state.records = data;
  },
  SET_LIST_FOLDERS(_state, data) {
    _state.folders = data;
  },
  ADD_CONTACT_LIST(_state, data) {
    _state.records = [..._state.records, data];
  },
  DELETE_CONTACT_LIST(_state, id) {
    _state.records = _state.records.filter(record => record.id !== id);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
